// Header functionality: scroll detection, transparent overlay transition, mobile menu

class ThangaHeader {
    constructor() {
        this.header = document.getElementById('site-header');
        this.mobileMenu = document.getElementById('mobile-menu');
        this.menuToggle = document.querySelector('[data-menu-toggle]');
        this.menuClose = document.querySelector('[data-menu-close]');
        this.searchToggle = document.querySelector('[data-search-toggle]');

        this.isTransparent = this.header.dataset.transparent === 'true';
        this.scrollThreshold = 100;

        this.init();
    }

    init() {
        /* REMOVED - Header should scroll away with page, not stick to top
        // Scroll detection for transparent header
        if (this.isTransparent) {
            this.handleScroll();
            window.addEventListener('scroll', window.thangaUtils.throttle(() => {
                this.handleScroll();
            }, 100));
        }
        */

        // Mobile menu toggle
        if (this.menuToggle) {
            this.menuToggle.addEventListener('click', () => this.openMobileMenu());
        }

        if (this.menuClose) {
            this.menuClose.addEventListener('click', () => this.closeMobileMenu());
        }

        // Mobile submenu toggles
        const mobileSubmenuToggles = document.querySelectorAll('.header__mobile-submenu-toggle');
        mobileSubmenuToggles.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                const submenu = toggle.parentElement.querySelector('.header__mobile-submenu');
                if (submenu) {
                    submenu.classList.toggle('active');

                    // Directly handle display block/none
                    if (submenu.classList.contains('active')) {
                        submenu.style.display = 'block';
                    } else {
                        submenu.style.display = 'none';
                    }

                    // Rotate icon
                    const isActive = submenu.classList.contains('active');
                    toggle.style.transform = isActive ? 'rotate(45deg)' : 'rotate(0deg)';
                }
            });
        });

        // Close mobile menu when clicking overlay
        if (this.mobileMenu) {
            this.mobileMenu.addEventListener('click', (e) => {
                if (e.target === this.mobileMenu) {
                    this.closeMobileMenu();
                }
            });
        }

        // Close mobile menu on ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.mobileMenu.classList.contains('active')) {
                this.closeMobileMenu();
            }
        });

        // Search toggle (placeholder - will be implemented in search section)
        if (this.searchToggle) {
            this.searchToggle.addEventListener('click', () => {
                // Trigger search overlay/modal
                document.dispatchEvent(new CustomEvent('search:toggle'));
            });
        }

        // Desktop dropdown hover handling (accessibility)
        const menuItemsWithDropdown = document.querySelectorAll('.header__menu-item--has-dropdown');
        menuItemsWithDropdown.forEach(item => {
            const link = item.querySelector('.header__menu-link');
            const submenuToggle = item.querySelector('.header__submenu-toggle');
            const submenu = item.querySelector('.header__submenu');

            // Click on toggle to show/hide dropdown
            if (submenuToggle) {
                submenuToggle.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    // Toggle aria-expanded
                    const isExpanded = submenuToggle.getAttribute('aria-expanded') === 'true';
                    submenuToggle.setAttribute('aria-expanded', !isExpanded);

                    // Toggle display
                    if (submenu) {
                        submenu.style.display = isExpanded ? 'none' : 'block';
                    }
                });
            }

            // Keyboard navigation
            item.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    if (document.activeElement === submenuToggle) {
                        e.preventDefault();
                        submenuToggle.click();
                    }
                }
            });
        });

        // Update cart count on cart update events
        document.addEventListener('cart:updated', (e) => {
            this.updateCartCount(e.detail.itemCount);
        });
    }

    /* REMOVED - No longer need scroll handling
    handleScroll() {
        const scrollY = window.scrollY;

        if (scrollY > this.scrollThreshold) {
            this.header.classList.add('header--scrolled');
        } else {
            this.header.classList.remove('header--scrolled');
        }
    }
    */

    openMobileMenu() {
        this.mobileMenu.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Focus trap
        this.focusTrap = window.thangaUtils.trapFocus(this.mobileMenu);
    }

    closeMobileMenu() {
        this.mobileMenu.classList.remove('active');
        document.body.style.overflow = '';

        if (this.focusTrap) {
            this.focusTrap.removeListeners();
        }

        this.menuToggle.focus();
    }

    updateCartCount(count) {
        const cartCountElement = document.getElementById('cart-count');
        if (cartCountElement) {
            cartCountElement.textContent = count;
        }
    }
}

// Initialize header when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new ThangaHeader();
    });
} else {
    new ThangaHeader();
}
